import Vue from 'vue'
import './plugins/axios'
import './filters/currency'
import './filters/customFilters'
import './plugins/print'
import App from './App.vue'
import router from './router'
import store from './store/store'
import vuetify from './plugins/vuetify';
import './assets/styles/app.scss'
import VueFilterDateFormat from '@vuejs-community/vue-filter-date-format';
import gaaVueLib from 'gaa-vue-lib';
// import VueGtag from "vue-gtag";

Vue.use(VueFilterDateFormat);


Vue.use(gaaVueLib, { store });

// if(process.env.VUE_APP_GA_MEASUREMENT_ID && process.env.VUE_APP_GA_MEASUREMENT_ID.startsWith('G-')){
//   Vue.use(VueGtag, {
//     config: { id: process.env.VUE_APP_GA_MEASUREMENT_ID }
//   }, router);
// }

Vue.config.productionTip = false
Vue.config.devtools = process.env.NODE_ENV === 'production' ? false : true;
Vue.config.debug = process.env.NODE_ENV === 'production' ? false : true;
Vue.config.silent = process.env.NODE_ENV === 'production' ? false : true;


new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  mounted() {
    window.onbeforeprint = () => {
      const element = document.querySelector('.v-main');
      if (element) {
        element.style.paddingTop = '0px';
      }
    }
    window.onafterprint = () => {
      const element = document.querySelector('.v-main');
      if (element) {
        element.style.paddingTop = '64px';
      }
    }
  }
}).$mount('#app')